import { string } from 'prop-types';
import { IUserColumns, IUserPortalDetails } from '../User/User';
import { IActivityModel } from '../Activity/Activity';
import { IActivityThemeModel } from '../ActivityTheme/ActivityTheme';
import jobfunctionPic from '../../images/Courses/jobfunktionkurser.jpg';
import ardejdomraadePic from '../../images/Courses/arbejdsomraadekurser.jpg';
import almenekurserPic from '../../images/Courses/almenekurser.jpg';

export enum CourseTags {
  SIDSTE_CHANGE = 'SIDSTE CHANGE',
  NYT = 'NYT',
  FOKUS = 'FOKUS'
}

export interface IAboutPageHtml {
  pageId: string;
  title: string;
  html: string;
}

export class DummyDatabase {
  public static AboutPageHtml: IAboutPageHtml[] = [
    {
      pageId: '0',
      title: 'Ansøgning og vilkår',
      html: ''
    },
    {
      pageId: '1',
      title: 'Om Kursusportalen',
      html: 'this is the pageId 1 html <br /> check for html input and redering'
    },
    {
      pageId: '2',
      title: 'Om kompetenceafklaring',
      html: 'this is the pageId 2 html <br /> check for html input and redering'
    }
  ];

  public static UserDetails: IUserColumns = {
    showInterests: false,
    id: 0,
    userId: 'stefank',
    personId: 5151155,
    forbundId: 32,
    union: 'FOA',
    arrangoerId: 32,
    department: ' FOA',
    name: 'Stefan Jones',
    address: '',
    zip: '4600',
    city: 'Køge',
    email: 'stefanj@frontavenue.com',
    mobile: '',
    telefonPrivate: '',
    telefonWork: '',
    portalDetails: {} as IUserPortalDetails,
    topicsDidSave: false,
    isAdministrator: true
  };
  public static UserPortalDetails = {
    topicInterests: ['11303821', '11303832', '11303834', '11303829'],
    courseFavorites: ['162676', '162680'],
    comingCourses: [{ detailKursusId: 162679, enbrollmentStatus: 'Ansøgning' }],
    openEvaluations: []
  };
  public static PortalData = [
    {
      themeId: 1400067,
      name: 'Almene Tværfaglige',
      buttonText: 'Se alle {antal kurser} kurser',
      description: null,
      themeImageUrl: 'https://placekitten.com/408/287',
      themeImg: null,
      categories: [
        {
          categoryId: 11303824,
          name: 'Ny i organisationen',
          activities: [
            {
              detailKursusId: 162676,
              courseTitle: 'Intro',
              fiuNo: '1999190008',
              startDate: null,
              startTime: null,
              endDate: null,
              endTime: null,
              courseLocation: null,
              isFocus: true,
              isCancelled: true,
              admStatus: 'K',
              subActivities: [
                {
                  lektionId: 304910,
                  name: 'Intro',
                  startDate: '2019-10-01',
                  startTime: '09:00',
                  endDate: '2019-10-05',
                  endTime: '16:00',
                  location:
                    '3F - Region Syddanmark - 3, Sjællandsgade 34, 1. , Vejle, 7100',
                  isSleepOver: true
                },
                {
                  lektionId: 304910,
                  name: 'Intro',
                  startDate: '2019-10-01',
                  startTime: '09:00',
                  endDate: '2019-10-05',
                  endTime: '16:00',
                  location:
                    '3F - Region Syddanmark - 3, Sjællandsgade 34, 1. , Vejle, 7100',
                  isSleepOver: true
                }
              ]
            },
            {
              detailKursusId: 162679,
              courseTitle: 'Intro',
              fiuNo: '1999190009',
              startDate: '2019-02-01',
              startTime: '09:00',
              endDate: '2019-02-05',
              endTime: '16:00',
              courseLocation:
                '3F - Region Syddanmark - 3, Sjællandsgade 34, 1. , Vejle, 7100',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304913,
                  name: 'Intro',
                  startDate: '2019-02-01',
                  startTime: '09:00',
                  endDate: '2019-02-05',
                  endTime: '16:00',
                  location:
                    '3F - Region Syddanmark - 3, Sjællandsgade 34, 1. , Vejle, 7100',
                  isSleepOver: true
                },
                {
                  lektionId: 304913,
                  name: 'Intro',
                  startDate: '2019-02-01',
                  startTime: '09:00',
                  endDate: '2019-02-05',
                  endTime: '16:00',
                  location:
                    '3F - Region Syddanmark - 3, Sjællandsgade 34, 1. , Vejle, 7100',
                  isSleepOver: true
                }
              ]
            },
            {
              detailKursusId: 162680,
              courseTitle: 'Intro for administrative',
              fiuNo: '1999190010',
              startDate: '2019-03-01',
              startTime: '10:00',
              endDate: '2019-03-05',
              endTime: '16:00',
              courseLocation: '3F Als, Nørreled 29, Guderup , Nordborg, 6430',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304914,
                  name: 'Intro for administrative',
                  startDate: '2019-03-01',
                  startTime: '10:00',
                  endDate: '2019-03-05',
                  endTime: '16:00',
                  location: '3F Als, Nørreled 29, Guderup , Nordborg, 6430',
                  isSleepOver: true
                },
                {
                  lektionId: 304914,
                  name: 'Intro for administrative',
                  startDate: '2019-03-01',
                  startTime: '10:00',
                  endDate: '2019-03-05',
                  endTime: '16:00',
                  location: '3F Als, Nørreled 29, Guderup , Nordborg, 6430',
                  isSleepOver: true
                },
                {
                  lektionId: 304914,
                  name: 'Intro for administrative',
                  startDate: '2019-03-01',
                  startTime: '10:00',
                  endDate: '2019-03-05',
                  endTime: '16:00',
                  location: '3F Als, Nørreled 29, Guderup , Nordborg, 6430',
                  isSleepOver: true
                }
              ]
            },
            {
              detailKursusId: 162682,
              courseTitle: 'Intro for konsulenter',
              fiuNo: '1999190011',
              startDate: '2019-04-01',
              startTime: '09:00',
              endDate: '2019-04-05',
              endTime: '16:00',
              courseLocation: '3F, Sæbygårdsvej 15 , Sæby, 9300',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304916,
                  name: 'Intro for konsulenter',
                  startDate: '2019-04-01',
                  startTime: '09:00',
                  endDate: '2019-04-05',
                  endTime: '16:00',
                  location: '3F, Sæbygårdsvej 15 , Sæby, 9300',
                  isSleepOver: true
                },
                {
                  lektionId: 304916,
                  name: 'Intro for konsulenter',
                  startDate: '2019-04-01',
                  startTime: '09:00',
                  endDate: '2019-04-05',
                  endTime: '16:00',
                  location: '3F, Sæbygårdsvej 15 , Sæby, 9300',
                  isSleepOver: true
                }
              ]
            }
          ]
        },
        {
          categoryId: 11303832,
          name: 'IT',
          activities: [
            {
              detailKursusId: 162651,
              courseTitle: 'IT - 3Fdok - Grundlæggende',
              fiuNo: '9115191401',
              startDate: '2019-02-04',
              startTime: '08:00',
              endDate: '2019-02-04',
              endTime: '16:00',
              courseLocation:
                '3F Hovedkontoret , Kampmannsgade 4 - IT lokalet K-2 -5 , København V, 1790',
              isFocus: false,
              publicationDate: '2022-08-20',
              subActivities: [
                {
                  lektionId: 304880,
                  name: 'IT - 3Fdok - Grundlæggende',
                  startDate: '2019-02-04',
                  startTime: '08:00',
                  endDate: '2019-02-04',
                  endTime: '16:00',
                  location:
                    '3F Hovedkontoret , Kampmannsgade 4 - IT lokalet K-2 -5 , København V, 1790',
                  isSleepOver: false
                },
                {
                  lektionId: 304880,
                  name: 'IT - 3Fdok - Grundlæggende',
                  startDate: '2019-02-04',
                  startTime: '08:00',
                  endDate: '2019-02-04',
                  endTime: '16:00',
                  location:
                    '3F Hovedkontoret , Kampmannsgade 4 - IT lokalet K-2 -5 , København V, 1790',
                  isSleepOver: false
                }
              ]
            },
            {
              detailKursusId: 162673,
              courseTitle: 'CRM Grundlæggende',
              fiuNo: '9115400101',
              startDate: '2019-04-17',
              startTime: '09:00',
              endDate: '2019-04-18',
              endTime: '16:00',
              courseLocation: '3F Kolding, Galgebjergvej 4 , Kolding, 6000',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304907,
                  name: 'CRM Grundlæggende',
                  startDate: '2019-04-17',
                  startTime: '09:00',
                  endDate: '2019-04-18',
                  endTime: '16:00',
                  location: '3F Kolding, Galgebjergvej 4 , Kolding, 6000',
                  isSleepOver: false
                },
                {
                  lektionId: 304907,
                  name: 'CRM Grundlæggende',
                  startDate: '2019-04-17',
                  startTime: '09:00',
                  endDate: '2019-04-18',
                  endTime: '16:00',
                  location: '3F Kolding, Galgebjergvej 4 , Kolding, 6000',
                  isSleepOver: false
                }
              ]
            }
          ]
        },
        {
          categoryId: 11303834,
          name: '3F Uddannelsen',
          activities: [
            {
              detailKursusId: 158867,
              courseTitle: 'A-kassekursus',
              fiuNo: '1944160012',
              startDate: '2019-10-10',
              startTime: '11:00',
              endDate: '2019-10-14',
              endTime: '12:00',
              courseLocation: 'Langsøhus, Vestre Ringvej 51 , Silkeborg, 8600',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 297640,
                  name: 'A-kassekursus',
                  startDate: '2019-10-10',
                  startTime: '11:00',
                  endDate: '2019-10-14',
                  endTime: '12:00',
                  location: 'Langsøhus, Vestre Ringvej 51 , Silkeborg, 8600',
                  isSleepOver: false
                },
                {
                  lektionId: 297640,
                  name: 'A-kassekursus',
                  startDate: '2019-10-10',
                  startTime: '11:00',
                  endDate: '2019-10-14',
                  endTime: '12:00',
                  location: 'Langsøhus, Vestre Ringvej 51 , Silkeborg, 8600',
                  isSleepOver: false
                },
                {
                  lektionId: 297640,
                  name: 'A-kassekursus',
                  startDate: '2019-10-10',
                  startTime: '11:00',
                  endDate: '2019-10-14',
                  endTime: '12:00',
                  location: 'Langsøhus, Vestre Ringvej 51 , Silkeborg, 8600',
                  isSleepOver: false
                },
                {
                  lektionId: 297640,
                  name: 'A-kassekursus',
                  startDate: '2019-10-10',
                  startTime: '11:00',
                  endDate: '2019-10-14',
                  endTime: '12:00',
                  location: 'Langsøhus, Vestre Ringvej 51 , Silkeborg, 8600',
                  isSleepOver: false
                }
              ]
            },
            {
              detailKursusId: 162606,
              courseTitle: '3F UDDANNELSEN URO - UGE 06',
              fiuNo: '1956197006',
              startDate: '2019-02-04',
              startTime: '10:00',
              endDate: '2019-02-06',
              endTime: '16:00',
              courseLocation:
                '3F Hovedkontoret, Kampmannsgade 4 , København V, 1604',
              isFocus: false,
              isAdvertisement: true,
              subActivities: [
                {
                  lektionId: 304818,
                  name: '3F UDDANNELSEN URO - UGE 06',
                  startDate: '2019-02-04',
                  startTime: '10:00',
                  endDate: '2019-02-06',
                  endTime: '16:00',
                  location:
                    '3F Hovedkontoret, Kampmannsgade 4 , København V, 1604',
                  isSleepOver: true
                },
                {
                  lektionId: 304818,
                  name: '3F UDDANNELSEN URO - UGE 06',
                  startDate: '2019-02-04',
                  startTime: '10:00',
                  endDate: '2019-02-06',
                  endTime: '16:00',
                  location:
                    '3F Hovedkontoret, Kampmannsgade 4 , København V, 1604',
                  isSleepOver: true
                }
              ]
            },
            {
              detailKursusId: 162610,
              courseTitle: '3F UDDANNELSEN URO - UGE 10',
              fiuNo: '1956197010',
              startDate: '2019-03-05',
              startTime: '10:00',
              endDate: '2019-03-07',
              endTime: '16:00',
              courseLocation:
                '3F Hovedkontoret, Kampmannsgade 4 , København V, 1604',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304822,
                  name: '3F UDDANNELSEN URO - UGE 10',
                  startDate: '2019-03-05',
                  startTime: '10:00',
                  endDate: '2019-03-07',
                  endTime: '16:00',
                  location:
                    '3F Hovedkontoret, Kampmannsgade 4 , København V, 1604',
                  isSleepOver: false
                },
                {
                  lektionId: 304822,
                  name: '3F UDDANNELSEN URO - UGE 10',
                  startDate: '2019-03-05',
                  startTime: '10:00',
                  endDate: '2019-03-07',
                  endTime: '16:00',
                  location:
                    '3F Hovedkontoret, Kampmannsgade 4 , København V, 1604',
                  isSleepOver: false
                }
              ]
            },
            {
              detailKursusId: 162612,
              courseTitle: '3F UDDANNELSEN URO - UGE 12',
              fiuNo: '1956197012',
              startDate: '2019-03-11',
              startTime: '10:00',
              endDate: '2019-03-13',
              endTime: '16:00',
              courseLocation:
                '3F Hovedkontoret, Kampmannsgade 4 , København V, 1604',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304824,
                  name: '3F UDDANNELSEN URO - UGE 12',
                  startDate: '2019-03-11',
                  startTime: '10:00',
                  endDate: '2019-03-13',
                  endTime: '16:00',
                  location:
                    '3F Hovedkontoret, Kampmannsgade 4 , København V, 1604',
                  isSleepOver: true
                },
                {
                  lektionId: 304824,
                  name: '3F UDDANNELSEN URO - UGE 12',
                  startDate: '2019-03-11',
                  startTime: '10:00',
                  endDate: '2019-03-13',
                  endTime: '16:00',
                  location:
                    '3F Hovedkontoret, Kampmannsgade 4 , København V, 1604',
                  isSleepOver: true
                }
              ]
            },
            {
              detailKursusId: 162614,
              courseTitle: '3F UDDANNELSEN URO - UGE 14',
              fiuNo: '1956197014',
              startDate: '2019-03-02',
              startTime: '10:00',
              endDate: '2019-03-04',
              endTime: '16:00',
              courseLocation: null,
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304826,
                  name: '3F UDDANNELSEN URO - UGE 14',
                  startDate: '2019-03-02',
                  startTime: '10:00',
                  endDate: '2019-03-04',
                  endTime: '16:00',
                  location: null,
                  isSleepOver: false
                },
                {
                  lektionId: 304826,
                  name: '3F UDDANNELSEN URO - UGE 14',
                  startDate: '2019-03-02',
                  startTime: '10:00',
                  endDate: '2019-03-04',
                  endTime: '16:00',
                  location: null,
                  isSleepOver: false
                }
              ]
            }
          ]
        },
        {
          categoryId: 11303840,
          name: 'Arbejdsmarked',
          activities: [
            {
              detailKursusId: 162688,
              courseTitle: 'Tidstagning på byggepladserne',
              fiuNo: '9115193001',
              startDate: '2019-07-22',
              startTime: '08:00',
              endDate: '2019-07-25',
              endTime: '16:00',
              courseLocation: '3F, Saltværksvej 68 , København S, 2300',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304922,
                  name: 'Tidstagning på byggepladserne',
                  startDate: '2019-07-22',
                  startTime: '08:00',
                  endDate: '2019-07-25',
                  endTime: '16:00',
                  location: '3F, Saltværksvej 68 , København S, 2300',
                  isSleepOver: false
                },
                {
                  lektionId: 304922,
                  name: 'Tidstagning på byggepladserne',
                  startDate: '2019-07-22',
                  startTime: '08:00',
                  endDate: '2019-07-25',
                  endTime: '16:00',
                  location: '3F, Saltværksvej 68 , København S, 2300',
                  isSleepOver: false
                },
                {
                  lektionId: 304922,
                  name: 'Tidstagning på byggepladserne',
                  startDate: '2019-07-22',
                  startTime: '08:00',
                  endDate: '2019-07-25',
                  endTime: '16:00',
                  location: '3F, Saltværksvej 68 , København S, 2300',
                  isSleepOver: false
                },
                {
                  lektionId: 304922,
                  name: 'Tidstagning på byggepladserne',
                  startDate: '2019-07-22',
                  startTime: '08:00',
                  endDate: '2019-07-25',
                  endTime: '16:00',
                  location: '3F, Saltværksvej 68 , København S, 2300',
                  isSleepOver: false
                }
              ]
            }
          ]
        },
        {
          categoryId: 11303841,
          name: 'Personlig udvikling',
          activities: [
            {
              detailKursusId: 162688,
              courseTitle: 'Tidstagning på byggepladserne',
              fiuNo: '9115193001',
              startDate: '2019-07-22',
              startTime: '08:00',
              endDate: '2019-07-25',
              endTime: '16:00',
              courseLocation: '3F, Saltværksvej 68 , København S, 2300',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304922,
                  name: 'Tidstagning på byggepladserne',
                  startDate: '2019-07-22',
                  startTime: '08:00',
                  endDate: '2019-07-25',
                  endTime: '16:00',
                  location: '3F, Saltværksvej 68 , København S, 2300',
                  isSleepOver: false
                },
                {
                  lektionId: 304922,
                  name: 'Tidstagning på byggepladserne',
                  startDate: '2019-07-22',
                  startTime: '08:00',
                  endDate: '2019-07-25',
                  endTime: '16:00',
                  location: '3F, Saltværksvej 68 , København S, 2300',
                  isSleepOver: false
                },
                {
                  lektionId: 304922,
                  name: 'Tidstagning på byggepladserne',
                  startDate: '2019-07-22',
                  startTime: '08:00',
                  endDate: '2019-07-25',
                  endTime: '16:00',
                  location: '3F, Saltværksvej 68 , København S, 2300',
                  isSleepOver: false
                },
                {
                  lektionId: 304922,
                  name: 'Tidstagning på byggepladserne',
                  startDate: '2019-07-22',
                  startTime: '08:00',
                  endDate: '2019-07-25',
                  endTime: '16:00',
                  location: '3F, Saltværksvej 68 , København S, 2300',
                  isSleepOver: false
                }
              ]
            }
          ]
        },
        {
          categoryId: 11303842,
          name: 'Organisering',
          activities: [
            {
              detailKursusId: 162684,
              courseTitle: 'Temadag organisering',
              fiuNo: '1999190012',
              startDate: '2019-05-01',
              startTime: '07:00',
              endDate: '2019-05-01',
              endTime: '16:00',
              courseLocation:
                '10 klassecenter, Vesthimmerland, Østre Boulevard 10 , Aars, 9600',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304918,
                  name: 'Temadag organisering',
                  startDate: '2019-05-01',
                  startTime: '07:00',
                  endDate: '2019-05-01',
                  endTime: '16:00',
                  location:
                    '10 klassecenter, Vesthimmerland, Østre Boulevard 10 , Aars, 9600',
                  isSleepOver: true
                },
                {
                  lektionId: 304918,
                  name: 'Temadag organisering',
                  startDate: '2019-05-01',
                  startTime: '07:00',
                  endDate: '2019-05-01',
                  endTime: '16:00',
                  location:
                    '10 klassecenter, Vesthimmerland, Østre Boulevard 10 , Aars, 9600',
                  isSleepOver: true
                }
              ]
            }
          ]
        },
        {
          categoryId: 11303844,
          name: 'Sagsbehandling',
          activities: [
            {
              detailKursusId: 162677,
              courseTitle: 'Sagsbehandling',
              fiuNo: '1944190404',
              startDate: '2019-04-15',
              startTime: '12:00',
              endDate: '2019-04-19',
              endTime: '16:00',
              courseLocation:
                '3F Hovedkontoret, Kampmannsgade 4 , København V, 1604',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304911,
                  name: 'Sagsbehandling',
                  startDate: '2019-04-15',
                  startTime: '12:00',
                  endDate: '2019-04-19',
                  endTime: '16:00',
                  location:
                    '3F Hovedkontoret, Kampmannsgade 4 , København V, 1604',
                  isSleepOver: false
                },
                {
                  lektionId: 304911,
                  name: 'Sagsbehandling',
                  startDate: '2019-04-15',
                  startTime: '12:00',
                  endDate: '2019-04-19',
                  endTime: '16:00',
                  location:
                    '3F Hovedkontoret, Kampmannsgade 4 , København V, 1604',
                  isSleepOver: false
                }
              ]
            }
          ]
        }
      ]
    },
    {
      themeId: 1400068,
      name: 'Jobfunktion',
      buttonText: 'knap {antal kurser}',
      description: 'Lorem ipsum',
      themeImg: null,
      categories: [
        {
          categoryId: 11303819,
          name: 'Faglig',
          activities: [
            {
              detailKursusId: 162630,
              courseTitle: 'Sygedagpenge for begyndere',
              fiuNo: '2301195001',
              startDate: '2019-03-20',
              startTime: '10:00',
              endDate: '2019-03-20',
              endTime: '15:00',
              courseLocation:
                '3F Hovedkontoret, Kampmannsgade 4 , København V, 1604',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304848,
                  name: 'Sygedagpenge for begyndere',
                  startDate: '2019-03-20',
                  startTime: '10:00',
                  endDate: '2019-03-20',
                  endTime: '15:00',
                  location:
                    '3F Hovedkontoret, Kampmannsgade 4 , København V, 1604',
                  isSleepOver: true
                },
                {
                  lektionId: 304848,
                  name: 'Sygedagpenge for begyndere',
                  startDate: '2019-03-20',
                  startTime: '10:00',
                  endDate: '2019-03-20',
                  endTime: '15:00',
                  location:
                    '3F Hovedkontoret, Kampmannsgade 4 , København V, 1604',
                  isSleepOver: true
                },
                {
                  lektionId: 304848,
                  name: 'Sygedagpenge for begyndere',
                  startDate: '2019-03-20',
                  startTime: '10:00',
                  endDate: '2019-03-20',
                  endTime: '15:00',
                  location:
                    '3F Hovedkontoret, Kampmannsgade 4 , København V, 1604',
                  isSleepOver: true
                }
              ]
            },
            {
              detailKursusId: 162648,
              courseTitle: 'Jura for ikke-jurister',
              fiuNo: '1944190003',
              startDate: '2019-03-11',
              startTime: '09:00',
              endDate: '2019-03-13',
              endTime: '16:00',
              courseLocation:
                '3F - Region Syddanmark - 3, Sjællandsgade 34, 1. , Vejle, 7100',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304877,
                  name: 'Jura for ikke-jurister',
                  startDate: '2019-03-11',
                  startTime: '09:00',
                  endDate: '2019-03-13',
                  endTime: '16:00',
                  location:
                    '3F - Region Syddanmark - 3, Sjællandsgade 34, 1. , Vejle, 7100',
                  isSleepOver: false
                },
                {
                  lektionId: 304877,
                  name: 'Jura for ikke-jurister',
                  startDate: '2019-03-11',
                  startTime: '09:00',
                  endDate: '2019-03-13',
                  endTime: '16:00',
                  location:
                    '3F - Region Syddanmark - 3, Sjællandsgade 34, 1. , Vejle, 7100',
                  isSleepOver: false
                },
                {
                  lektionId: 304877,
                  name: 'Jura for ikke-jurister',
                  startDate: '2019-03-11',
                  startTime: '09:00',
                  endDate: '2019-03-13',
                  endTime: '16:00',
                  location:
                    '3F - Region Syddanmark - 3, Sjællandsgade 34, 1. , Vejle, 7100',
                  isSleepOver: false
                },
                {
                  lektionId: 304877,
                  name: 'Jura for ikke-jurister',
                  startDate: '2019-03-11',
                  startTime: '09:00',
                  endDate: '2019-03-13',
                  endTime: '16:00',
                  location:
                    '3F - Region Syddanmark - 3, Sjællandsgade 34, 1. , Vejle, 7100',
                  isSleepOver: false
                }
              ]
            }
          ]
        },
        {
          categoryId: 11303821,
          name: 'Socialrådgiver/arbejdsskadesagsbehandler',
          activities: [
            {
              detailKursusId: 162631,
              courseTitle: 'Sygedagpenge',
              fiuNo: '2301195003',
              startDate: '2019-10-08',
              startTime: '09:00',
              endDate: '2019-10-08',
              endTime: '15:00',
              courseLocation:
                '3F - Region Syddanmark - 3, Sjællandsgade 34, 1. , Vejle, 7100',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304849,
                  name: 'Sygedagpenge',
                  startDate: '2019-10-08',
                  startTime: '09:00',
                  endDate: '2019-10-08',
                  endTime: '15:00',
                  location:
                    '3F - Region Syddanmark - 3, Sjællandsgade 34, 1. , Vejle, 7100',
                  isSleepOver: true
                },
                {
                  lektionId: 304849,
                  name: 'Sygedagpenge',
                  startDate: '2019-10-08',
                  startTime: '09:00',
                  endDate: '2019-10-08',
                  endTime: '15:00',
                  location:
                    '3F - Region Syddanmark - 3, Sjællandsgade 34, 1. , Vejle, 7100',
                  isSleepOver: true
                }
              ]
            },
            {
              detailKursusId: 162648,
              courseTitle: 'Jura for ikke-jurister',
              fiuNo: '1944190003',
              startDate: '2019-03-11',
              startTime: '09:00',
              endDate: '2019-03-13',
              endTime: '16:00',
              courseLocation:
                '3F - Region Syddanmark - 3, Sjællandsgade 34, 1. , Vejle, 7100',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304877,
                  name: 'Jura for ikke-jurister',
                  startDate: '2019-03-11',
                  startTime: '09:00',
                  endDate: '2019-03-13',
                  endTime: '16:00',
                  location:
                    '3F - Region Syddanmark - 3, Sjællandsgade 34, 1. , Vejle, 7100',
                  isSleepOver: false
                },
                {
                  lektionId: 304877,
                  name: 'Jura for ikke-jurister',
                  startDate: '2019-03-11',
                  startTime: '09:00',
                  endDate: '2019-03-13',
                  endTime: '16:00',
                  location:
                    '3F - Region Syddanmark - 3, Sjællandsgade 34, 1. , Vejle, 7100',
                  isSleepOver: false
                },
                {
                  lektionId: 304877,
                  name: 'Jura for ikke-jurister',
                  startDate: '2019-03-11',
                  startTime: '09:00',
                  endDate: '2019-03-13',
                  endTime: '16:00',
                  location:
                    '3F - Region Syddanmark - 3, Sjællandsgade 34, 1. , Vejle, 7100',
                  isSleepOver: false
                },
                {
                  lektionId: 304877,
                  name: 'Jura for ikke-jurister',
                  startDate: '2019-03-11',
                  startTime: '09:00',
                  endDate: '2019-03-13',
                  endTime: '16:00',
                  location:
                    '3F - Region Syddanmark - 3, Sjællandsgade 34, 1. , Vejle, 7100',
                  isSleepOver: false
                }
              ]
            },
            {
              detailKursusId: 162672,
              courseTitle: 'Arbejdsskadesikringsloven',
              fiuNo: '2301190005',
              startDate: '2019-03-25',
              startTime: '10:00',
              endDate: '2019-07-27',
              endTime: '16:07',
              courseLocation: 'Smålandshavet, Alleen 44 , Karrebæksminde, 4736',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304902,
                  name: 'Arbejdsskadesikringsloven',
                  startDate: '2019-03-25',
                  startTime: '10:00',
                  endDate: '2019-03-27',
                  endTime: '16:00',
                  location: 'Smålandshavet, Alleen 44 , Karrebæksminde, 4736',
                  isSleepOver: false
                },
                {
                  lektionId: 304903,
                  name: 'Arbejdsskadesikringsloven 2. del',
                  startDate: '2019-04-25',
                  startTime: '10:00',
                  endDate: '2019-04-27',
                  endTime: '16:00',
                  location: 'Snaptun Færgegård, Havnevej 11 , Horsens, 8700',
                  isSleepOver: true
                },
                {
                  lektionId: 304904,
                  name: 'Arbejdsskadesikringsloven 3. del',
                  startDate: '2019-05-25',
                  startTime: '10:00',
                  endDate: '2019-06-27',
                  endTime: '16:00',
                  location: 'Smålandshavet, Alleen 44 , Karrebæksminde, 4736',
                  isSleepOver: false
                },
                {
                  lektionId: 304905,
                  name: 'Arbejdsskadesikringsloven 4. del',
                  startDate: '2019-06-25',
                  startTime: '11:00',
                  endDate: '2019-06-27',
                  endTime: '16:00',
                  location: 'Smålandshavet, Alleen 44 , Karrebæksminde, 4736',
                  isSleepOver: false
                },
                {
                  lektionId: 304906,
                  name: 'Arbejdsskadesikringsloven 5. del',
                  startDate: '2019-07-25',
                  startTime: '10:07',
                  endDate: '2019-07-27',
                  endTime: '16:07',
                  location: 'Snaptun Færgegård, Havnevej 11 , Horsens, 8700',
                  isSleepOver: true
                },
                {
                  lektionId: 304902,
                  name: 'Arbejdsskadesikringsloven',
                  startDate: '2019-03-25',
                  startTime: '10:00',
                  endDate: '2019-03-27',
                  endTime: '16:00',
                  location: 'Smålandshavet, Alleen 44 , Karrebæksminde, 4736',
                  isSleepOver: false
                },
                {
                  lektionId: 304903,
                  name: 'Arbejdsskadesikringsloven 2. del',
                  startDate: '2019-04-25',
                  startTime: '10:00',
                  endDate: '2019-04-27',
                  endTime: '16:00',
                  location: 'Snaptun Færgegård, Havnevej 11 , Horsens, 8700',
                  isSleepOver: true
                },
                {
                  lektionId: 304904,
                  name: 'Arbejdsskadesikringsloven 3. del',
                  startDate: '2019-05-25',
                  startTime: '10:00',
                  endDate: '2019-06-27',
                  endTime: '16:00',
                  location: 'Smålandshavet, Alleen 44 , Karrebæksminde, 4736',
                  isSleepOver: false
                },
                {
                  lektionId: 304905,
                  name: 'Arbejdsskadesikringsloven 4. del',
                  startDate: '2019-06-25',
                  startTime: '11:00',
                  endDate: '2019-06-27',
                  endTime: '16:00',
                  location: 'Smålandshavet, Alleen 44 , Karrebæksminde, 4736',
                  isSleepOver: false
                },
                {
                  lektionId: 304906,
                  name: 'Arbejdsskadesikringsloven 5. del',
                  startDate: '2019-07-25',
                  startTime: '10:07',
                  endDate: '2019-07-27',
                  endTime: '16:07',
                  location: 'Snaptun Færgegård, Havnevej 11 , Horsens, 8700',
                  isSleepOver: true
                }
              ]
            }
          ]
        },
        {
          categoryId: 11303822,
          name: 'Leder',
          activities: [
            {
              detailKursusId: 162632,
              courseTitle: 'Leder - kom igennem med dit budskab',
              fiuNo: '1999190001',
              startDate: '2019-03-27',
              startTime: '10:00',
              endDate: '2019-03-28',
              endTime: '16:00',
              courseLocation: 'Laugesens Have, Knivsbækvej 13 , Videbæk, 6920',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304850,
                  name: 'Leder - kom igennem med dit budskab',
                  startDate: '2019-03-27',
                  startTime: '10:00',
                  endDate: '2019-03-28',
                  endTime: '16:00',
                  location: 'Laugesens Have, Knivsbækvej 13 , Videbæk, 6920',
                  isSleepOver: false
                },
                {
                  lektionId: 304850,
                  name: 'Leder - kom igennem med dit budskab',
                  startDate: '2019-03-27',
                  startTime: '10:00',
                  endDate: '2019-03-28',
                  endTime: '16:00',
                  location: 'Laugesens Have, Knivsbækvej 13 , Videbæk, 6920',
                  isSleepOver: false
                }
              ]
            }
          ]
        },
        {
          categoryId: 11303826,
          name: 'A-kasse',
          activities: [
            {
              detailKursusId: 158867,
              courseTitle: 'A-kassekursus',
              fiuNo: '1944160012',
              startDate: '2019-10-10',
              startTime: '11:00',
              endDate: '2019-10-14',
              endTime: '12:00',
              courseLocation: 'Langsøhus, Vestre Ringvej 51 , Silkeborg, 8600',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 297640,
                  name: 'A-kassekursus',
                  startDate: '2019-10-10',
                  startTime: '11:00',
                  endDate: '2019-10-14',
                  endTime: '12:00',
                  location: 'Langsøhus, Vestre Ringvej 51 , Silkeborg, 8600',
                  isSleepOver: false
                },
                {
                  lektionId: 297640,
                  name: 'A-kassekursus',
                  startDate: '2019-10-10',
                  startTime: '11:00',
                  endDate: '2019-10-14',
                  endTime: '12:00',
                  location: 'Langsøhus, Vestre Ringvej 51 , Silkeborg, 8600',
                  isSleepOver: false
                },
                {
                  lektionId: 297640,
                  name: 'A-kassekursus',
                  startDate: '2019-10-10',
                  startTime: '11:00',
                  endDate: '2019-10-14',
                  endTime: '12:00',
                  location: 'Langsøhus, Vestre Ringvej 51 , Silkeborg, 8600',
                  isSleepOver: false
                },
                {
                  lektionId: 297640,
                  name: 'A-kassekursus',
                  startDate: '2019-10-10',
                  startTime: '11:00',
                  endDate: '2019-10-14',
                  endTime: '12:00',
                  location: 'Langsøhus, Vestre Ringvej 51 , Silkeborg, 8600',
                  isSleepOver: false
                }
              ]
            },
            {
              detailKursusId: 162630,
              courseTitle: 'Sygedagpenge for begyndere',
              fiuNo: '2301195001',
              startDate: '2019-03-20',
              startTime: '10:00',
              endDate: '2019-03-20',
              endTime: '15:00',
              courseLocation:
                '3F Hovedkontoret, Kampmannsgade 4 , København V, 1604',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304848,
                  name: 'Sygedagpenge for begyndere',
                  startDate: '2019-03-20',
                  startTime: '10:00',
                  endDate: '2019-03-20',
                  endTime: '15:00',
                  location:
                    '3F Hovedkontoret, Kampmannsgade 4 , København V, 1604',
                  isSleepOver: true
                },
                {
                  lektionId: 304848,
                  name: 'Sygedagpenge for begyndere',
                  startDate: '2019-03-20',
                  startTime: '10:00',
                  endDate: '2019-03-20',
                  endTime: '15:00',
                  location:
                    '3F Hovedkontoret, Kampmannsgade 4 , København V, 1604',
                  isSleepOver: true
                },
                {
                  lektionId: 304848,
                  name: 'Sygedagpenge for begyndere',
                  startDate: '2019-03-20',
                  startTime: '10:00',
                  endDate: '2019-03-20',
                  endTime: '15:00',
                  location:
                    '3F Hovedkontoret, Kampmannsgade 4 , København V, 1604',
                  isSleepOver: true
                }
              ]
            },
            {
              detailKursusId: 162648,
              courseTitle: 'Jura for ikke-jurister',
              fiuNo: '1944190003',
              startDate: '2019-03-11',
              startTime: '09:00',
              endDate: '2019-03-13',
              endTime: '16:00',
              courseLocation:
                '3F - Region Syddanmark - 3, Sjællandsgade 34, 1. , Vejle, 7100',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304877,
                  name: 'Jura for ikke-jurister',
                  startDate: '2019-03-11',
                  startTime: '09:00',
                  endDate: '2019-03-13',
                  endTime: '16:00',
                  location:
                    '3F - Region Syddanmark - 3, Sjællandsgade 34, 1. , Vejle, 7100',
                  isSleepOver: false
                },
                {
                  lektionId: 304877,
                  name: 'Jura for ikke-jurister',
                  startDate: '2019-03-11',
                  startTime: '09:00',
                  endDate: '2019-03-13',
                  endTime: '16:00',
                  location:
                    '3F - Region Syddanmark - 3, Sjællandsgade 34, 1. , Vejle, 7100',
                  isSleepOver: false
                },
                {
                  lektionId: 304877,
                  name: 'Jura for ikke-jurister',
                  startDate: '2019-03-11',
                  startTime: '09:00',
                  endDate: '2019-03-13',
                  endTime: '16:00',
                  location:
                    '3F - Region Syddanmark - 3, Sjællandsgade 34, 1. , Vejle, 7100',
                  isSleepOver: false
                },
                {
                  lektionId: 304877,
                  name: 'Jura for ikke-jurister',
                  startDate: '2019-03-11',
                  startTime: '09:00',
                  endDate: '2019-03-13',
                  endTime: '16:00',
                  location:
                    '3F - Region Syddanmark - 3, Sjællandsgade 34, 1. , Vejle, 7100',
                  isSleepOver: false
                }
              ]
            },
            {
              detailKursusId: 162665,
              courseTitle: 'Grundlæggende a-kasse - modul1',
              fiuNo: '1944190402',
              startDate: '2019-04-01',
              startTime: '00:00',
              endDate: '2019-04-05',
              endTime: '16:00',
              courseLocation: '3F, Søndergade 62 , Aalborg, 9000',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304895,
                  name: 'Grundlæggende a-kasse - modul1',
                  startDate: '2019-04-01',
                  startTime: '00:00',
                  endDate: '2019-04-05',
                  endTime: '16:00',
                  location: '3F, Søndergade 62 , Aalborg, 9000',
                  isSleepOver: false
                },
                {
                  lektionId: 304895,
                  name: 'Grundlæggende a-kasse - modul1',
                  startDate: '2019-04-01',
                  startTime: '00:00',
                  endDate: '2019-04-05',
                  endTime: '16:00',
                  location: '3F, Søndergade 62 , Aalborg, 9000',
                  isSleepOver: false
                }
              ]
            },
            {
              detailKursusId: 162671,
              courseTitle: 'Grundlæggende a-kasse-modul 2',
              fiuNo: '1944190403',
              startDate: '2019-04-08',
              startTime: '12:00',
              endDate: '2019-04-12',
              endTime: '12:00',
              courseLocation:
                'Hovedkontoret , Industriens Mødelokale 4.sal Kampmannsgade 4, København V, 1790',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304901,
                  name: 'Grundlæggende a-kasse-modul 2',
                  startDate: '2019-04-08',
                  startTime: '12:00',
                  endDate: '2019-04-12',
                  endTime: '12:00',
                  location:
                    'Hovedkontoret , Industriens Mødelokale 4.sal Kampmannsgade 4, København V, 1790',
                  isSleepOver: true
                },
                {
                  lektionId: 304901,
                  name: 'Grundlæggende a-kasse-modul 2',
                  startDate: '2019-04-08',
                  startTime: '12:00',
                  endDate: '2019-04-12',
                  endTime: '12:00',
                  location:
                    'Hovedkontoret , Industriens Mødelokale 4.sal Kampmannsgade 4, København V, 1790',
                  isSleepOver: true
                }
              ]
            }
          ]
        },
        {
          categoryId: 11303830,
          name: 'Opmåler',
          activities: [
            {
              detailKursusId: 162688,
              courseTitle: 'Tidstagning på byggepladserne',
              fiuNo: '9115193001',
              startDate: '2019-07-22',
              startTime: '08:00',
              endDate: '2019-07-25',
              endTime: '16:00',
              courseLocation: '3F, Saltværksvej 68 , København S, 2300',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304922,
                  name: 'Tidstagning på byggepladserne',
                  startDate: '2019-07-22',
                  startTime: '08:00',
                  endDate: '2019-07-25',
                  endTime: '16:00',
                  location: '3F, Saltværksvej 68 , København S, 2300',
                  isSleepOver: false
                },
                {
                  lektionId: 304922,
                  name: 'Tidstagning på byggepladserne',
                  startDate: '2019-07-22',
                  startTime: '08:00',
                  endDate: '2019-07-25',
                  endTime: '16:00',
                  location: '3F, Saltværksvej 68 , København S, 2300',
                  isSleepOver: false
                },
                {
                  lektionId: 304922,
                  name: 'Tidstagning på byggepladserne',
                  startDate: '2019-07-22',
                  startTime: '08:00',
                  endDate: '2019-07-25',
                  endTime: '16:00',
                  location: '3F, Saltværksvej 68 , København S, 2300',
                  isSleepOver: false
                },
                {
                  lektionId: 304922,
                  name: 'Tidstagning på byggepladserne',
                  startDate: '2019-07-22',
                  startTime: '08:00',
                  endDate: '2019-07-25',
                  endTime: '16:00',
                  location: '3F, Saltværksvej 68 , København S, 2300',
                  isSleepOver: false
                }
              ]
            }
          ]
        },
        {
          categoryId: 11303846,
          name: 'Den Grønne Gruppe',
          activities: [
            {
              detailKursusId: 162685,
              courseTitle: 'Temadag for mejerister',
              fiuNo: '1999190013',
              startDate: '2019-07-05',
              startTime: '10:00',
              endDate: '2019-07-05',
              endTime: '16:00',
              courseLocation: ' NNF Kolding, Grønningen 41 , Kolding, 6000',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304919,
                  name: 'Temadag for mejerister',
                  startDate: '2019-07-05',
                  startTime: '10:00',
                  endDate: '2019-07-05',
                  endTime: '16:00',
                  location: ' NNF Kolding, Grønningen 41 , Kolding, 6000',
                  isSleepOver: true
                },
                {
                  lektionId: 304919,
                  name: 'Temadag for mejerister',
                  startDate: '2019-07-05',
                  startTime: '10:00',
                  endDate: '2019-07-05',
                  endTime: '16:00',
                  location: ' NNF Kolding, Grønningen 41 , Kolding, 6000',
                  isSleepOver: true
                }
              ]
            }
          ]
        },
        {
          categoryId: 11303851,
          name: 'Konsulent',
          activities: [
            {
              detailKursusId: 162686,
              courseTitle: 'Selvstændige aktiviteter',
              fiuNo: '1944190005',
              startDate: '2019-05-29',
              startTime: '09:00',
              endDate: '2019-05-29',
              endTime: '16:00',
              courseLocation: 'Smålandshavet, Alleen 44 , Karrebæksminde, 4736',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304920,
                  name: 'Selvstændige aktiviteter',
                  startDate: '2019-05-29',
                  startTime: '09:00',
                  endDate: '2019-05-29',
                  endTime: '16:00',
                  location: 'Smålandshavet, Alleen 44 , Karrebæksminde, 4736',
                  isSleepOver: false
                },
                {
                  lektionId: 304920,
                  name: 'Selvstændige aktiviteter',
                  startDate: '2019-05-29',
                  startTime: '09:00',
                  endDate: '2019-05-29',
                  endTime: '16:00',
                  location: 'Smålandshavet, Alleen 44 , Karrebæksminde, 4736',
                  isSleepOver: false
                }
              ]
            }
          ]
        },
        {
          categoryId: 11303852,
          name: 'Administration',
          activities: [
            {
              detailKursusId: 162680,
              courseTitle: 'Intro for administrative',
              fiuNo: '1999190010',
              startDate: '2019-03-01',
              startTime: '10:00',
              endDate: '2019-03-05',
              endTime: '16:00',
              courseLocation: '3F Als, Nørreled 29, Guderup , Nordborg, 6430',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304914,
                  name: 'Intro for administrative',
                  startDate: '2019-03-01',
                  startTime: '10:00',
                  endDate: '2019-03-05',
                  endTime: '16:00',
                  location: '3F Als, Nørreled 29, Guderup , Nordborg, 6430',
                  isSleepOver: true
                },
                {
                  lektionId: 304914,
                  name: 'Intro for administrative',
                  startDate: '2019-03-01',
                  startTime: '10:00',
                  endDate: '2019-03-05',
                  endTime: '16:00',
                  location: '3F Als, Nørreled 29, Guderup , Nordborg, 6430',
                  isSleepOver: true
                },
                {
                  lektionId: 304914,
                  name: 'Intro for administrative',
                  startDate: '2019-03-01',
                  startTime: '10:00',
                  endDate: '2019-03-05',
                  endTime: '16:00',
                  location: '3F Als, Nørreled 29, Guderup , Nordborg, 6430',
                  isSleepOver: true
                }
              ]
            }
          ]
        }
      ]
    },
    {
      themeId: 1400069,
      name: 'Arbejdsområde',
      description: null,
      themeImg: null,
      categories: [
        {
          categoryId: 11303827,
          name: 'Arbejdsmiljø',
          activities: [
            {
              detailKursusId: 162686,
              courseTitle: 'Selvstændige aktiviteter',
              fiuNo: '1944190005',
              startDate: '2019-05-29',
              startTime: '09:00',
              endDate: '2019-05-29',
              endTime: '16:00',
              courseLocation: 'Smålandshavet, Alleen 44 , Karrebæksminde, 4736',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304920,
                  name: 'Selvstændige aktiviteter',
                  startDate: '2019-05-29',
                  startTime: '09:00',
                  endDate: '2019-05-29',
                  endTime: '16:00',
                  location: 'Smålandshavet, Alleen 44 , Karrebæksminde, 4736',
                  isSleepOver: false
                },
                {
                  lektionId: 304920,
                  name: 'Selvstændige aktiviteter',
                  startDate: '2019-05-29',
                  startTime: '09:00',
                  endDate: '2019-05-29',
                  endTime: '16:00',
                  location: 'Smålandshavet, Alleen 44 , Karrebæksminde, 4736',
                  isSleepOver: false
                }
              ]
            },
            {
              detailKursusId: 162687,
              courseTitle: 'Kreativitet med Franne',
              fiuNo: '1944190405',
              startDate: '2019-04-22',
              startTime: '08:00',
              endDate: '2019-04-24',
              endTime: '16:00',
              courseLocation:
                '"Igangsætteren" AOF Kursuscenter, Støden 3, 3. sal , Roskilde, 4000',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304921,
                  name: 'Kreativitet med Franne',
                  startDate: '2019-04-22',
                  startTime: '08:00',
                  endDate: '2019-04-24',
                  endTime: '16:00',
                  location:
                    '"Igangsætteren" AOF Kursuscenter, Støden 3, 3. sal , Roskilde, 4000',
                  isSleepOver: false
                },
                {
                  lektionId: 304921,
                  name: 'Kreativitet med Franne',
                  startDate: '2019-04-22',
                  startTime: '08:00',
                  endDate: '2019-04-24',
                  endTime: '16:00',
                  location:
                    '"Igangsætteren" AOF Kursuscenter, Støden 3, 3. sal , Roskilde, 4000',
                  isSleepOver: false
                }
              ]
            },
            {
              detailKursusId: 162688,
              courseTitle: 'Tidstagning på byggepladserne',
              fiuNo: '9115193001',
              startDate: '2019-07-22',
              startTime: '08:00',
              endDate: '2019-07-25',
              endTime: '16:00',
              courseLocation: '3F, Saltværksvej 68 , København S, 2300',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304922,
                  name: 'Tidstagning på byggepladserne',
                  startDate: '2019-07-22',
                  startTime: '08:00',
                  endDate: '2019-07-25',
                  endTime: '16:00',
                  location: '3F, Saltværksvej 68 , København S, 2300',
                  isSleepOver: false
                },
                {
                  lektionId: 304922,
                  name: 'Tidstagning på byggepladserne',
                  startDate: '2019-07-22',
                  startTime: '08:00',
                  endDate: '2019-07-25',
                  endTime: '16:00',
                  location: '3F, Saltværksvej 68 , København S, 2300',
                  isSleepOver: false
                },
                {
                  lektionId: 304922,
                  name: 'Tidstagning på byggepladserne',
                  startDate: '2019-07-22',
                  startTime: '08:00',
                  endDate: '2019-07-25',
                  endTime: '16:00',
                  location: '3F, Saltværksvej 68 , København S, 2300',
                  isSleepOver: false
                },
                {
                  lektionId: 304922,
                  name: 'Tidstagning på byggepladserne',
                  startDate: '2019-07-22',
                  startTime: '08:00',
                  endDate: '2019-07-25',
                  endTime: '16:00',
                  location: '3F, Saltværksvej 68 , København S, 2300',
                  isSleepOver: false
                }
              ]
            },
            {
              detailKursusId: 162689,
              courseTitle: 'Temadag KVINDE SLÅ IGEN',
              fiuNo: '1999190014',
              startDate: '2019-03-08',
              startTime: '19:00',
              endDate: '2019-03-08',
              endTime: '22:00',
              courseLocation: 'Agerskov Kro, Hovedgaden 3 , Agerskov, 6534',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304923,
                  name: 'Temadag KVINDE SLÅ IGEN',
                  startDate: '2019-03-08',
                  startTime: '19:00',
                  endDate: '2019-03-08',
                  endTime: '22:00',
                  location: 'Agerskov Kro, Hovedgaden 3 , Agerskov, 6534',
                  isSleepOver: true
                },
                {
                  lektionId: 304923,
                  name: 'Temadag KVINDE SLÅ IGEN',
                  startDate: '2019-03-08',
                  startTime: '19:00',
                  endDate: '2019-03-08',
                  endTime: '22:00',
                  location: 'Agerskov Kro, Hovedgaden 3 , Agerskov, 6534',
                  isSleepOver: true
                }
              ]
            },
            {
              detailKursusId: 162691,
              courseTitle: 'Ungdomslandsmøde',
              fiuNo: '1999190016',
              startDate: '2019-12-23',
              startTime: '09:00',
              endDate: '2019-12-24',
              endTime: '16:00',
              courseLocation: 'Langsøhus, Vestre Ringvej 51 , Silkeborg, 8600',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304925,
                  name: 'Ungdomslandsmøde',
                  startDate: '2019-12-23',
                  startTime: '09:00',
                  endDate: '2019-12-24',
                  endTime: '16:00',
                  location: 'Langsøhus, Vestre Ringvej 51 , Silkeborg, 8600',
                  isSleepOver: false
                },
                {
                  lektionId: 304925,
                  name: 'Ungdomslandsmøde',
                  startDate: '2019-12-23',
                  startTime: '09:00',
                  endDate: '2019-12-24',
                  endTime: '16:00',
                  location: 'Langsøhus, Vestre Ringvej 51 , Silkeborg, 8600',
                  isSleepOver: false
                }
              ]
            }
          ]
        },
        {
          categoryId: 11303829,
          name: 'Ungdom',
          activities: [
            {
              detailKursusId: 162691,
              courseTitle: 'Ungdomslandsmøde',
              fiuNo: '1999190016',
              startDate: '2019-12-23',
              startTime: '09:00',
              endDate: '2019-12-24',
              endTime: '16:00',
              courseLocation: 'Langsøhus, Vestre Ringvej 51 , Silkeborg, 8600',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304925,
                  name: 'Ungdomslandsmøde',
                  startDate: '2019-12-23',
                  startTime: '09:00',
                  endDate: '2019-12-24',
                  endTime: '16:00',
                  location: 'Langsøhus, Vestre Ringvej 51 , Silkeborg, 8600',
                  isSleepOver: false
                },
                {
                  lektionId: 304925,
                  name: 'Ungdomslandsmøde',
                  startDate: '2019-12-23',
                  startTime: '09:00',
                  endDate: '2019-12-24',
                  endTime: '16:00',
                  location: 'Langsøhus, Vestre Ringvej 51 , Silkeborg, 8600',
                  isSleepOver: false
                }
              ]
            }
          ]
        },
        {
          categoryId: 11303835,
          name: 'Ligestilling og mangfoldighed',
          activities: [
            {
              detailKursusId: 162687,
              courseTitle: 'Kreativitet med Franne',
              fiuNo: '1944190405',
              startDate: '2019-04-22',
              startTime: '08:00',
              endDate: '2019-04-24',
              endTime: '16:00',
              courseLocation:
                '"Igangsætteren" AOF Kursuscenter, Støden 3, 3. sal , Roskilde, 4000',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304921,
                  name: 'Kreativitet med Franne',
                  startDate: '2019-04-22',
                  startTime: '08:00',
                  endDate: '2019-04-24',
                  endTime: '16:00',
                  location:
                    '"Igangsætteren" AOF Kursuscenter, Støden 3, 3. sal , Roskilde, 4000',
                  isSleepOver: false
                },
                {
                  lektionId: 304921,
                  name: 'Kreativitet med Franne',
                  startDate: '2019-04-22',
                  startTime: '08:00',
                  endDate: '2019-04-24',
                  endTime: '16:00',
                  location:
                    '"Igangsætteren" AOF Kursuscenter, Støden 3, 3. sal , Roskilde, 4000',
                  isSleepOver: false
                }
              ]
            },
            {
              detailKursusId: 162689,
              courseTitle: 'Temadag KVINDE SLÅ IGEN',
              fiuNo: '1999190014',
              startDate: '2019-03-08',
              startTime: '19:00',
              endDate: '2019-03-08',
              endTime: '22:00',
              courseLocation: 'Agerskov Kro, Hovedgaden 3 , Agerskov, 6534',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 304923,
                  name: 'Temadag KVINDE SLÅ IGEN',
                  startDate: '2019-03-08',
                  startTime: '19:00',
                  endDate: '2019-03-08',
                  endTime: '22:00',
                  location: 'Agerskov Kro, Hovedgaden 3 , Agerskov, 6534',
                  isSleepOver: true
                },
                {
                  lektionId: 304923,
                  name: 'Temadag KVINDE SLÅ IGEN',
                  startDate: '2019-03-08',
                  startTime: '19:00',
                  endDate: '2019-03-08',
                  endTime: '22:00',
                  location: 'Agerskov Kro, Hovedgaden 3 , Agerskov, 6534',
                  isSleepOver: true
                }
              ]
            }
          ]
        },
        {
          categoryId: 11303836,
          name: 'IT superbruger',
          activities: [
            {
              detailKursusId: 158867,
              courseTitle: 'A-kassekursus',
              fiuNo: '1944160012',
              startDate: '2019-10-10',
              startTime: '11:00',
              endDate: '2019-10-14',
              endTime: '12:00',
              courseLocation: 'Langsøhus, Vestre Ringvej 51 , Silkeborg, 8600',
              isFocus: false,
              subActivities: [
                {
                  lektionId: 297640,
                  name: 'A-kassekursus',
                  startDate: '2019-10-10',
                  startTime: '11:00',
                  endDate: '2019-10-14',
                  endTime: '12:00',
                  location: 'Langsøhus, Vestre Ringvej 51 , Silkeborg, 8600',
                  isSleepOver: false
                },
                {
                  lektionId: 297640,
                  name: 'A-kassekursus',
                  startDate: '2019-10-10',
                  startTime: '11:00',
                  endDate: '2019-10-14',
                  endTime: '12:00',
                  location: 'Langsøhus, Vestre Ringvej 51 , Silkeborg, 8600',
                  isSleepOver: false
                },
                {
                  lektionId: 297640,
                  name: 'A-kassekursus',
                  startDate: '2019-10-10',
                  startTime: '11:00',
                  endDate: '2019-10-14',
                  endTime: '12:00',
                  location: 'Langsøhus, Vestre Ringvej 51 , Silkeborg, 8600',
                  isSleepOver: false
                },
                {
                  lektionId: 297640,
                  name: 'A-kassekursus',
                  startDate: '2019-10-10',
                  startTime: '11:00',
                  endDate: '2019-10-14',
                  endTime: '12:00',
                  location: 'Langsøhus, Vestre Ringvej 51 , Silkeborg, 8600',
                  isSleepOver: false
                }
              ]
            }
          ]
        }
      ]
    }
  ];
}



// WEBPACK FOOTER //
// ./src/Entities/DataDummy/Data.ts